$(document).ready(function(){

  /***************************Disable Right Click on PDP *************************/
  $('#shopify-section-product-template').bind('contextmenu', function(event) {
    if (!$(event.target).closest('.customRight h1.product_name').length) {
      return false;
    }
  }); 

  $('body #dialogProSlide img').bind('contextmenu', function(event) {
    if (!$(event.target).closest('.customRight h1.product_name').length) {
      return false;
    }
  })
  $('body.product').bind('contextmenu', function(event) {
    if (!$(event.target).closest('.customRight h1.product_name').length) {
      return false;
    }

  }); 

  /********************** Blank Div Hide On PDP  *****************************/
  $(".item_slider img").each(function(i){
    i = i+1;
    var getattr = $(this).attr("src");
    if(getattr == "")
    {
      if (i % 2 === 0) {
      }
      else{
        $(this).parents(".item_slider").css("display","none");
      }
    }
    else{
      //console.log("NOt Blank");
    }
  })

  $(".review_count .jdgm-widget.jdgm-widget").click(function(e){
    e.preventDefault();
    //$(".ReviewTab").trigger("click");
    $('html, body').animate({
      'scrollTop' : $(".ReviewTab").position().top
    });
  })
  /********************** Bot And Shoes Size Chart  *****************************/
  $(".customBoot li").click(function(){
    var IDGET = $(this).attr("data-id");
    $(".customBoot li").each(function(){
      $(this).removeClass("active");
    })
    $(this).addClass("active");
    $(".containerPart").css("display","none");
    $("#"+IDGET).css("display","block");

  })
  $(".customdimensions.inches ").click(function(){
    $(this).addClass("active");
    $(".size-chart-cm").removeClass("active");
    $(".size-chart-inches-target").css("display","table");
    $(".size-chart-cm-target").css("display","none");
  })
  $(".customdimensions.size-chart-cm ").click(function(){
    $(this).addClass("active");
    $(".inches").removeClass("active");
    $(".size-chart-inches-target").css("display","none");
    $(".size-chart-cm-target").css("display","table");
  })

  $(".ShoesTab.table-bordered.size-chart-inches-target tbody tr td").hover(function(){
    var firstcolNum = $(this).attr("data-row");
    firstcolNum = parseInt(firstcolNum);
    var RowNum = $(this).parent("tr").attr("data-main");;
    $(this).toggleClass("Main-focus");
    $(this).siblings("td").toggleClass("sibling-focus");
    $(".ShoesTab.table-bordered.size-chart-inches-target tbody tr").each(function(index){
      if(index < RowNum){
        console.log("index:-"+index);
        console.log("RowNum:-"+RowNum);
        $(this).toggleClass("testingpurpose");
        $(this).children("td").each(function(){
          var colNum = $(this).attr("data-row");
          colNum = parseInt(colNum);
          if(colNum == firstcolNum){
            $(this).toggleClass("sibling-focus");
          }
        })

      }
    })
    $(".ShoesTab.table-bordered.size-chart-inches-target .main-head-inch").each(function(index){
      $(this).children("th").each(function(){
        var colNum = $(this).attr("data-row");
        colNum = parseInt(colNum);
        if(colNum == firstcolNum){
          $(this).toggleClass("Main-focus");
        }
      })
    })
  })

  $(".ShoesTab.table-bordered.size-chart-cm-target tbody tr td").hover(function(){
    var firstcolNum = $(this).attr("data-row");
    firstcolNum = parseInt(firstcolNum);
    var RowNum = $(this).parent("tr").attr("data-main");;
    $(this).toggleClass("Main-focus");
    $(this).siblings("td").toggleClass("sibling-focus");
    $(".ShoesTab.table-bordered.size-chart-cm-target tbody tr").each(function(index){
      if(index < RowNum){
        console.log("index:-"+index);
        console.log("RowNum:-"+RowNum);
        $(this).toggleClass("testingpurpose");
        $(this).children("td").each(function(){
          var colNum = $(this).attr("data-row");
          colNum = parseInt(colNum);
          if(colNum == firstcolNum){
            $(this).toggleClass("sibling-focus");
          }
        })

      }
    })
    $(".ShoesTab.table-bordered.size-chart-cm-target .main-head-cm").each(function(index){
      $(this).children("th").each(function(){
        var colNum = $(this).attr("data-row");
        colNum = parseInt(colNum);
        if(colNum == firstcolNum){
          $(this).toggleClass("Main-focus");
        }
      })
    })
  })
  /********************** Vertcal SLider On Product Page  *****************************/
  $(function() {
    $('.MobileMainSliderr').slick({
      dots: true
    });

    $('.MobileMainSliderr').show();
  });

  $('.customNavigations').slick({slidesToShow: 4,vertical: true});
  /**************************Size Chart     ********************************/   

  $('#size_cart_men .measure .size-chart-inches').click(function(){
    $(this).addClass('active');
    $('#size_cart_men .measure .size-chart-cm').removeClass('active');
    $('#size_cart_men .size-chart-inches-target').removeClass('hidden');
    $('#size_cart_men .size-chart-cm-target').addClass('hidden')
  });
  $('#size_cart_men .measure .size-chart-cm').click(function(){
    $(this).addClass('active');
    $('#size_cart_men .measure .size-chart-inches').removeClass('active');
    $('#size_cart_men .size-chart-inches-target').addClass('hidden');
    $('#size_cart_men .size-chart-cm-target').removeClass('hidden')
  });

  $('#size_cart_women .measure .size-chart-inches').click(function(){
    $(this).addClass('active');
    $('#size_cart_women .measure .size-chart-cm').removeClass('active');
    $('#size_cart_women .size-chart-inches-target').removeClass('hidden');
    $('#size_cart_women .size-chart-cm-target').addClass('hidden')
  });
  $('#size_cart_women .measure .size-chart-cm').click(function(){
    $(this).addClass('active');
    $('#size_cart_women .measure .size-chart-inches').removeClass('active');
    $('#size_cart_women .size-chart-inches-target').addClass('hidden');
    $('#size_cart_women .size-chart-cm-target').removeClass('hidden')
  });

  $(".sizechart-cst.MainContainerMen .men_tableCus.size-chart-inches-target td").hover(

    function(){
      console.log("HOVER 1");
      var limit = $(this).parent("tr").attr("data-max");
      limit = limit-1;
      limit = parseInt(limit);
      var tdNum = $(this).attr("data-number");
      tdNum = parseInt(tdNum);
      $(this).toggleClass("dark_hover");
      $(this).prevUntil(".first_colum","td").toggleClass("light_hover");
      $(this).parent("tr").children(".first_colum").toggleClass("dark_hover");
      var maximum = $(this).parent("tr").attr("data-max");
      $(".men_tableCus.size-chart-inches-target thead tr th").each(function(){
        var thNum = $(this).attr("data-number");
        if(thNum == tdNum){
          $(this).toggleClass("dark_hover");
        }
      })
      $(".MainContainerMen .men_tableCus.size-chart-inches-target tbody  tr").each(function(index){
        if(index < limit){

          $(this).children("td").each(function(){
            var tdNumAll = $(this).attr("data-number");
            tdNumAll = parseInt(tdNumAll);
            if(tdNumAll == tdNum){
              $(this).toggleClass("light_hover");
            }
          })
        }
      })
      $(this).removeClass("light_hover");
    })

  $(".sizechart-cst.MainContainerMen .men_tableCus.size-chart-cm-target td").hover(

    function(){
      console.log("HOVER 2");
      var limit = $(this).parent("tr").attr("data-max");
      var tdNum = $(this).attr("data-number");
      $(this).toggleClass("dark_hover");
      $(this).prevUntil(".first_colum","td").toggleClass("light_hover");
      $(this).parent("tr").children(".first_colum").toggleClass("dark_hover");
      var maximum = $(this).parent("tr").attr("data-max");
      $(".men_tableCus.size-chart-cm-target thead tr th").each(function(){
        var thNum = $(this).attr("data-number");
        if(thNum == tdNum){
          $(this).toggleClass("dark_hover");
        }
      })
      $(".MainContainerMen .men_tableCus.size-chart-cm-target tbody  tr").each(function(index){

        if(index < limit-1){
          $(this).children("td").each(function(){
            var tdNumAll = $(this).attr("data-number");
            if(tdNumAll == tdNum){
              $(this).toggleClass("light_hover");
            }
          })
        }
      })
      $(this).removeClass("light_hover");
    })

  $(".MainContainerWomen .sizechart-cst .women_tableCus.size-chart-inches-target td").hover(

    function(){
      console.log("HOVER 3");
      var limit = $(this).parent("tr").attr("data-max");
      var tdNum = $(this).attr("data-number");
      $(this).toggleClass("dark_hover");
      $(this).prevUntil(".first_colum","td").toggleClass("light_hover");
      $(this).parent("tr").children(".first_colum").toggleClass("dark_hover");
      var maximum = $(this).parent("tr").attr("data-max");
      $(".women_tableCus.size-chart-inches-target thead tr th").each(function(){
        var thNum = $(this).attr("data-number");
        if(thNum == tdNum){
          $(this).toggleClass("dark_hover");
        }
      })
      $(".MainContainerWomen .women_tableCus.size-chart-inches-target tbody  tr").each(function(index){

        if(index < limit-1){
          $(this).children("td").each(function(){
            var tdNumAll = $(this).attr("data-number");
            if(tdNumAll == tdNum){
              $(this).toggleClass("light_hover");
            }
          })
        }
      })
      $(this).removeClass("light_hover");
    })

  $(".MainContainerWomen .sizechart-cst .women_tableCus.size-chart-cm-target td").hover(

    function(){
      console.log("HOVER 4");
      var limit = $(this).parent("tr").attr("data-max");
      var tdNum = $(this).attr("data-number");
      $(this).toggleClass("dark_hover");
      $(this).prevUntil(".first_colum","td").toggleClass("light_hover");
      $(this).parent("tr").children(".first_colum").toggleClass("dark_hover");
      var maximum = $(this).parent("tr").attr("data-max");
      $(".women_tableCus.size-chart-cm-target thead tr th").each(function(){
        var thNum = $(this).attr("data-number");
        if(thNum == tdNum){
          $(this).toggleClass("dark_hover");
        }
      })
      $(".MainContainerWomen .women_tableCus.size-chart-cm-target tbody  tr").each(function(index){

        if(index < limit-1){
          $(this).children("td").each(function(){
            var tdNumAll = $(this).attr("data-number");
            if(tdNumAll == tdNum){
              $(this).toggleClass("light_hover");
            }
          })
        }
      })
      $(this).removeClass("light_hover");
    })

  $(".MenTab").click(function(){
    $(this).addClass("active");
    $(".WomenTab").removeClass("active");
    $("#size_cart_men").css("display","block");
    $("#size_cart_women").css("display","none");
  })
  $(".WomenTab").click(function(){
    $(this).addClass("active");
    $(".MenTab").removeClass("active");
    $("#size_cart_men").css("display","none");
    $("#size_cart_women").css("display","block");
  })

})